<template>
  <div class="container" :class="{ whatBG: page == 'what' }">
    <WhyPage :page="page" />
    <NavBar @goTo="goToPage($event)" :page="page" />
    <WhoPage @goTo="goToPage($event)" :page="page" />
    <WhatPage @goTo="goToPage($event)" :page="page" />
    <WorkPage @goTo="goToPage($event)" :page="page" />
  </div>
  <div class="mobile-cont">
    <HomePageVue />
  </div>
</template>
<script>
import NavBar from "@/components/header/NavBar.vue";
import WhyPage from "./pages/WhyPage.vue";
import WhoPage from "./pages/WhoPage.vue";
import WhatPage from "./pages/WhatPage.vue";
import WorkPage from "./pages/WorkPage.vue";
import { computed, ref } from "vue";
import HomePageVue from "./mobile/HomePage.vue";
export default {
  components: {
    NavBar,
    WhyPage,
    WhoPage,
    WhatPage,
    WorkPage,
    HomePageVue,
  },
  setup() {
    const page = ref("who");
    const goToPage = (p) => {
      console.log(page);
      page.value = p;
    };
    const isPhone = window.matchMedia("(max-width: 1025px)");
    const checkMQ = computed(() => {
      if (isPhone.matches) {
        return true;
      }
      return false;
    });
    return {
      goToPage,
      page,
      checkMQ,
    };
  },
};
</script>
<style lang="scss">
@keyframes upDown {
  0% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(10px);
  }
}

.container {
  background: #041c32;
  box-sizing: border-box;
  height: 100%;
}
.whatBG {
  background: #04293a;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
.slide-enter-active {
  animation: slide-in 0.5s;
}
.slide-leave-active {
  animation: slide-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(50vh);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes slide-in {
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(0);
  }
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    position: absolute;
    border: 4px solid #fff;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    &::nth-child(2) {
      animation-delay: -0.5s;
    }
  }
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

@media screen and (min-width: 700px) {
  .container {
    display: block;
  }
  .mobile-cont {
    display: none;
  }
}
@media screen and (max-width: 700px) {
  .container {
    display: none;
  }
  .mobile-cont {
    display: block;
  }
}
</style>
